import { render, staticRenderFns } from "./HighlightVideoText.vue?vue&type=template&id=564b3061&scoped=true"
import script from "./HighlightVideoText.vue?vue&type=script&lang=js"
export * from "./HighlightVideoText.vue?vue&type=script&lang=js"
import style0 from "./HighlightVideoText.vue?vue&type=style&index=0&id=564b3061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b3061",
  null
  
)

export default component.exports